export const LedgerItemTypes = Object.freeze({
    EXPENSE: 'EXPENSE',
    INCOME: 'INCOME',
});
